<script setup>
import { ref, computed } from 'vue';
import { storeToRefs } from 'pinia';
import { values } from 'lodash-es';
import { useAddressStore } from '@stores/useAddressStore';
import { URL_ADDRESS_PAGE } from '@tools/routes/routes';
import { trans } from '@elements/translation';
import AddressDetailsDashboard from './AddressDetailsDashboard.vue';
import AddressDetailsTabs from './AddressDetailsTabs.vue';

const backLink = ref(URL_ADDRESS_PAGE);
const store = useAddressStore();
const {
  setAddress,
  setInitialPageSpace,
  setCurrentPageSpace,
  setCompletePageSpaceUrl,
  setAllowedImageFormat,
} = store;

setAddress(window.ADDRESS);
setInitialPageSpace(window.PAGE_SPACE);
setCurrentPageSpace(window.PAGE_SPACE);
setCompletePageSpaceUrl(window.PAGE_SPACE_URL);
setAllowedImageFormat(
  values(window.IMAGE_FORMATS_MIMETYPES ?? []).join(', '),
);

const { address } = storeToRefs(store);
const addressTitle = computed(() => {
  if (address.value.name !== '') {
    return address.value.name;
  }
  return address.value.get_formatted_name;
});
</script>

<template>
  <div class="address-details">
    <h1>{{ addressTitle }}</h1>
    <a class="address-details__back-link" :href="backLink">{{ trans('addresses.details.view.go_back') }}</a>
    <div class="address-details__content details-content">
      <AddressDetailsTabs :address="address" />
      <AddressDetailsDashboard :address="address" />
    </div>
  </div>
</template>
